import { Modal } from "react-bootstrap"
import { Controller, useForm } from "react-hook-form";
import Select from 'react-select';
import { shareChartForReview } from "../../services/chartService";
import { useParams } from "react-router-dom";
import { useState } from "react";


function ShareForReviewModal({ show, onHide, auditors }) {
    const { id: chartId } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const {
        handleSubmit,
        control,
        reset,
        formState: { errors }
    } = useForm();

    const renderAuditors = () => auditors?.map((auditor) => ({ value: auditor?.id, label: `${auditor?.first_name} ${auditor?.last_name}` }))
    const onSubmit = async (data) => {
        try {
            if (!chartId) return;
            setIsLoading(true);
            const res = await shareChartForReview({id: data?.auditors?.value}, chartId);
            if (res.success) {
                window.toastr.success(res.message);
                handleHide();
            } else {
                window.toastr.error(res.message);
            }
        } catch (error) {
            window.toastr.error(error.message);
        }
        setIsLoading(false);
    };

    const handleHide = () => {
        onHide();
        reset({
            auditors: '',
        });
    }

    return (
        <Modal show={show} centered onHide={handleHide}>
            <Modal.Header closeButton>
                <Modal.Title>Share for Review</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               <div className="fs-7 text-danger">Note:&nbsp;<span>This invitation is solely for review purpose and will not allocate the chart to the selected user.</span></div>
                <form className="col-md-12 fv-row mt-5" onSubmit={handleSubmit(onSubmit)}>
                    <Controller
                        name="auditors"
                        control={control}
                        rules={{
                            required: { value: true, message: 'Required' },
                        }}
                        render={({ field }) => (
                            <Select
                                {...field}
                                components={{ IndicatorSeparator: () => null }}
                                isClearable
                                options={renderAuditors()}
                                placeholder="Select Auditor"
                            />
                        )}
                    />
                    {errors?.auditors
                        && <div className="text-danger small pt-2"> {errors.auditors?.message} </div>}
                    <button className="btn btn-primary mt-4 float-end">Invite { isLoading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> }</button>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default ShareForReviewModal